import React from 'react'

function SettingAdmin() {
  return (
    <div>SettingAdmin</div>
  )
}

export default SettingAdmin